import { useCallback, useState } from "react";
import api from "../../services/api";

const FORMAT_TO_MIME = {
  IMAGE: ["image/jpeg", "image/png"],
  VIDEO: ["video/mp4", "video/3gpp"],
  DOCUMENT: [
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/vnd.ms-powerpoint",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    "text/plain"
  ]
};

const MAX_SIZE_MB = { IMAGE: 5, VIDEO: 16, DOCUMENT: 100 };

export function getAcceptForFormat(format) {
  if (!FORMAT_TO_MIME[format]) return "";
  return FORMAT_TO_MIME[format].join(",");
}

export function validateFile(file, format) {
  if (!file) return "Arquivo não selecionado.";
  const allowed = FORMAT_TO_MIME[format] || [];
  if (allowed.length > 0 && !allowed.includes(file.type)) {
    return `Tipo de arquivo inválido para ${format}. Esperado: ${allowed.join(", ")}.`;
  }
  const maxMB = MAX_SIZE_MB[format];
  if (maxMB && file.size > maxMB * 1024 * 1024) {
    return `Arquivo excede ${maxMB}MB.`;
  }
  return null;
}

export function useTemplateMediaUpload(whatsappId) {
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState(null);

  const upload = useCallback(
    async (file) => {
      if (!whatsappId) {
        const e = "Selecione uma conexão antes de fazer upload.";
        setError(e);
        throw new Error(e);
      }
      setUploading(true);
      setError(null);
      try {
        const formData = new FormData();
        formData.append("file", file);

        const { data } = await api.post(
          `/whatsapp/${whatsappId}/message-templates/upload-media`,
          formData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );
        return data?.data || null;
      } catch (err) {
        const msg = err?.response?.data?.error || err?.response?.data?.message || err.message;
        setError(msg);
        throw err;
      } finally {
        setUploading(false);
      }
    },
    [whatsappId]
  );

  return { upload, uploading, error };
}
